import identityReducer from '../common/identity-reducer';
import identityReducerData from '../common/identity-reducer-data';
import listReducer from '../common/list-reducer';

import {
    eventsAction,
    getStoreAction,
    setActiveEventAction,
    getDashboardInfoAction,
    getSubscriptionAction
} from "./actions";

const eventsReducer = listReducer.bind(eventsAction.getListReduceThisObj());
const storeReducer = identityReducerData.bind(getStoreAction.getIdentityReducerThisObj({}))
const activeEventReducer = identityReducer.bind(setActiveEventAction.getIdentityReducerThisObj(0));
const dashboardReducer = identityReducerData.bind(getDashboardInfoAction.getIdentityReducerThisObj({}));
const subscriptionReducer = identityReducerData.bind(getSubscriptionAction.getIdentityReducerThisObj({}));

export default ({
    events: eventsReducer,
    store: storeReducer,
    activeEvent: activeEventReducer,
    dashboard: dashboardReducer,
    subscription: subscriptionReducer
});